import { Link, useLocation } from 'react-router-dom';
import { LogIn } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Login Icon (Desktop-only)
 *
 * Fixed positionierter Button oben rechts, links neben dem Theme-Toggle.
 * Nur für nicht-angemeldete User sichtbar.
 * Nicht auf Login/Register Seiten (dort redundant).
 *
 * Position: right-16.
 */
export const TWLoginIcon = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // Während Auth-Loading nicht rendern (verhindert Flackern)
  if (isLoading) {
    return null;
  }

  // Nur für nicht-angemeldete User
  if (isAuthenticated) {
    return null;
  }

  // Nicht auf Login/Register Pages (dort redundant)
  if (location.pathname === '/login' || location.pathname === '/register') {
    return null;
  }

  // Auf der Landing Page (inkl. V2) den dunklen Hintergrund verwenden
  const isLandingPage = location.pathname === '/' || location.pathname === '/v2';

  return (
    <Link
      to="/login"
      data-mask-snap-target="login"
      className={`
        fixed top-4 right-4 sm:right-16 z-[10001]
        flex items-center justify-center
        w-10 h-10 rounded-full
        cursor-pointer
        ${isLandingPage
          ? 'bg-[#0d0d0d] shadow-lg shadow-black/20 border border-gray-800/50'
          : 'bg-white/90 dark:bg-gray-800/90 backdrop-blur-sm shadow-lg shadow-black/10 dark:shadow-black/30 border border-gray-200 dark:border-gray-700 transition-all duration-300 hover:scale-110 hover:shadow-xl'
        }
      `}
      title="Anmelden"
      aria-label="Zur Anmeldeseite"
    >
      <LogIn size={20} className="text-brand transition-colors duration-300" />
    </Link>
  );
};

export default TWLoginIcon;
